import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { ReactNode } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileBottomSheet } from "@/components/MobileBottomSheet";
import { SearchTriggerButton } from "@/components/CalculatorSearchDialog";
import { Link } from "react-router-dom";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const isMobile = useIsMobile();
  
  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="flex min-h-screen w-full overflow-x-hidden">
        {!isMobile && <AppSidebar />}
        <SidebarInset className="flex flex-1 flex-col min-w-0 overflow-x-hidden">
          {/* Mobile Header - Brand Left, Menu Right */}
          {isMobile && (
            <header className="sticky top-0 z-40 flex items-center justify-between border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 py-3 safe-area-inset-top">
              <Link to="/" className="flex flex-col">
                <span className="text-lg font-bold text-foreground tracking-tight">
                  Calculator<span className="text-primary">Sheet</span>
                </span>
                <span className="text-[10px] text-muted-foreground font-medium -mt-1">
                  by Utiloom
                </span>
              </Link>
              <div className="flex items-center gap-1.5">
                <SearchTriggerButton collapsed={true} />
                <MobileBottomSheet />
              </div>
            </header>
          )}
          <main className="flex-1 min-w-0 overflow-x-hidden">{children}</main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}